import React, { useState } from 'react';

import {
  Box,
  List,
  Link,
  Stack,
  Button,
  Dialog,
  Switch,
  ListItem,
  Typography,
  DialogTitle,
  ListItemText,
  DialogActions,
  DialogContent,
  FormControlLabel,
} from '@mui/material';

import { useResponsive } from '../../../../hooks';

import { useCookieConsent } from '../../hooks';

interface BannerHeights {
  DESKTOP: string;
  MOBILE: string;
}

interface CookieConsentProps {
  bannerHeights: BannerHeights;
}

const CookieConsent = ({ bannerHeights }: CookieConsentProps) => {
  const { giveConsent, shouldDisplayCookieBanner } = useCookieConsent();

  const smDown = useResponsive('down', 'sm');

  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleAccept = () => {
    giveConsent();
  };
  if (!shouldDisplayCookieBanner) {
    return null;
  }

  return (
    <>
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Cookie Preferences</DialogTitle>
        <DialogContent>
          <Typography variant="body1" paragraph>
            We use cookies to keep you logged in and ensure the proper functioning of our website.
            These are essential cookies that are necessary for the website to work correctly.
          </Typography>
          <List>
            <ListItem>
              <ListItemText
                primary="Essential Cookies"
                secondary="These cookies are required to enable core functionality of the website. They help keep you logged in and ensure the security of your session. You cannot disable these cookies as they are necessary for the website to function properly."
              />
              <FormControlLabel
                control={<Switch checked disabled color="primary" />}
                label="Always active"
                labelPlacement="start"
              />
            </ListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} variant="outlined" sx={{ color: '#516600' }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: smDown ? bannerHeights.MOBILE : bannerHeights.DESKTOP,
          backgroundColor: '#0D5257',
          zIndex: (theme) => theme.zIndex.appBar + 2,
          padding: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            maxWidth: '800px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Typography color="white" variant="h1" gutterBottom>
            Cookies on AgileChain
          </Typography>
          <Typography color="white" variant="body2" gutterBottom>
            We use only essential cookies to keep you logged in and ensure our website functions
            properly. These cookies don&apos;t track your activity for marketing purposes. By
            continuing to use our site, you agree to our use of these necessary cookies.
          </Typography>
          <Typography color="white" variant="body2" gutterBottom>
            <Link href="/eula" target="_blank" color="inherit" sx={{ textDecoration: 'underline' }}>
              View our End User Licence Agreement
            </Link>
          </Typography>
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              onClick={handleAccept}
              sx={{ alignSelf: 'flex-start', mt: 1, backgroundColor: '#516600' }}
            >
              Accept Essential Cookies
            </Button>
            <Button
              onClick={handleOpenDialog}
              variant="outlined"
              sx={{ alignSelf: 'flex-start', mt: 1, color: 'white' }}
            >
              View Cookies
            </Button>
          </Stack>
        </Box>
      </Box>
    </>
  );
};

export default CookieConsent;
